import { type ToolRendererRegistry } from '@multiplayer-app/ai-agent-react'
import { OfficeApplyRenderer } from './OfficeApplyRenderer'
import { OfficeReadRenderer } from './OfficeReadRenderer'

/**
 * Renderers keyed by the (server) tool name: write tools get the apply card,
 * document read tools get the minimal activity line.
 */
export const officeToolRenderers: ToolRendererRegistry = {
  insertWordText: OfficeApplyRenderer,
  appendWordText: OfficeApplyRenderer,
  replaceWordSelection: OfficeApplyRenderer,
  replaceWordText: OfficeApplyRenderer,
  replaceWordParagraphs: OfficeApplyRenderer,
  replaceWordDocument: OfficeApplyRenderer,
  applyWordEdits: OfficeApplyRenderer,
  writeExcelRange: OfficeApplyRenderer,
  insertPowerPointText: OfficeApplyRenderer,
  getWordDocumentOutline: OfficeReadRenderer,
  readWordParagraphs: OfficeReadRenderer,
  searchWordDocumentText: OfficeReadRenderer,
  getExcelWorkbookOutline: OfficeReadRenderer,
  readExcelRows: OfficeReadRenderer,
  searchExcelCells: OfficeReadRenderer,
  getCurrentOfficeSelection: OfficeReadRenderer
}
